import { Component } from '@angular/core';
import { LoaderService } from '../../../core/services/loader.service';

@Component({  standalone: false,
  selector: 'app-loader',
  template: `<div class="loader-overlay" *ngIf="loaderService.loading$ | async"><div class="spinner"></div></div>`,
  styles: [`
    .loader-overlay { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(255,255,255,0.6); display: flex; align-items: center; justify-content: center; z-index: 9999; }
    .spinner { width: 40px; height: 40px; border: 4px solid #e0e0e0; border-top: 4px solid #1976d2; border-radius: 50%; animation: spin 0.8s linear infinite; }
    @keyframes spin { to { transform: rotate(360deg); } }
  `]
})
export class LoaderComponent {
  constructor(public loaderService: LoaderService) {}
}
